import { useEffect, useMemo } from "react";
import dayjs from "dayjs";
import { i18n } from "i18next";

export type UseInternationalizationProps = (params: {
  i18n: i18n;
  locale: string;
}) => void;

type SupportedLanguages =
  | "fr"
  | "de"
  | "en"
  | "es"
  | "it"
  | "vi"
  | "ca"
  | "pt"
  | "fi"
  | "tr";

const localeToLang = {
  fr: "fr",
  de: "de",
  gb: "en",
  en: "en",
  es: "es",
  ca: "ca",
  it: "it",
  vi: "vi",
  pt: "pt",
  fi: "fi",
  us: "en",
  tr: "tr",
};

function mapLocaleToLang(locale: string): SupportedLanguages {
  return localeToLang[locale?.toLowerCase()] || "fr";
}

export const useInternationalization: UseInternationalizationProps = ({
  i18n,
  locale,
}) => {
  const lang = useMemo(() => {
    return mapLocaleToLang(locale);
  }, [locale]);

  useEffect(() => {
    if (lang) {
      document.documentElement.lang = lang;
      i18n.changeLanguage(lang);
      dayjs.locale(lang);
    }
  }, [lang, i18n]);
};
